<template>
  <div>
    <div style="text-align: right; z-index: 1000;">
      <!--送测人再次送呈及确认-->
      <el-button v-if="(formData.State === 1 || formData.State === 3) && $store.state.Login.User === formData.Applicant"
        @click="qianhe = true" size="small" style="text-align: right;" type="warning">
        {{ $t('All.签核') }}
      </el-button>
      <!--实验室确认及签核-->
      <el-button
        v-if="(formData.State === 0 || formData.State === 2 || formData.State === 4) && this.$store.state.Login.Department == 'Test'"
        @click="qianhe = true" size="small" style="text-align: right;" type="warning">
        {{ $t('All.签核') }}
      </el-button>
      <!--超管权限-->
      <el-button v-if="$store.state.Login.Jurisdiction === 0" @click="qianhe = true" size="small"
        style="text-align: right;" type="primary">
        {{ $t('All.签核') }}
      </el-button>
      <!--超管权限-->
      <el-button v-if="formData.State === 10" size="small" @click="Resendtest(formData.Numbers)"
        style="text-align: right;" type="warning">
        {{ $t('All.重送') }}
      </el-button>
    </div>
    <h2 style="text-align: center;">{{ $t('system.company') }}</h2>
    <h3 style="text-align: center;">{{ }}</h3>
    <h4 style="text-align: center;">{{ $t('All.通知单号') }}:{{ formData.Numbers }}</h4>
    <h4 style="text-align: center;">{{ $t('All.开单日期') }}:{{ formData.Date }}</h4>
    <h4 style="text-align: center;">{{ $t('All.当前状态') }}:{{ $PublicJs.Resultyilds(formData.State) }}</h4>
    <el-form ref="elForm" :model="formData" :rules="rules" style="max-width: 90%;margin: auto;padding-bottom: 2px;"
      size="medium" label-width="90px" label-position="top">
      <el-form-item :label="$t('system.部门')" prop="Department">
        <span v-if="formData.State !== 1">{{ formData.Department }}</span>
        <el-select v-else v-model="formData.Department" allow-create filterable :placeholder="this.$t('All.请选择')"
          :style="{ width: '100%' }">
          <el-option v-for="item in $PublicJs.testdepartment" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="this.$t('All.工单号')" prop="Gongdan">
        <span v-if="formData.State !== 1">{{ formData.Gongdan }}</span>
        <el-input v-else v-model="formData.Gongdan" :placeholder="this.$t('All.实验工单提醒')" clearable
          :style="{ width: '100%' }">
        </el-input>
      </el-form-item>
      <el-form-item :label="this.$t('All.品名') + '/' + this.$t('All.料号')" prop="Product_item">
        <span v-if="formData.State !== 1">{{ formData.Product_item }}</span>
        <el-input v-else v-model="formData.Product_item" :placeholder="this.$t('All.请输入品名料号')" clearable
          :style="{ width: '100%' }">
        </el-input>
      </el-form-item>
      <el-form-item :label="this.$t('All.客户') + '/' + this.$t('All.厂商')" prop="Customer_manufacturer">
        <span v-if="formData.State !== 1">{{ formData.Customer_manufacturer }}</span>
        <el-input v-else v-model="formData.Customer_manufacturer" :placeholder="this.$t('All.请输入客户厂商')" clearable
          :style="{ width: '100%' }"></el-input>
      </el-form-item>
      <el-form-item :label="this.$t('All.样品数量')" prop="Quantity">
        <span v-if="formData.State !== 1">{{ formData.Quantity }}</span>
        <el-input v-else v-model="formData.Quantity" :placeholder="this.$t('All.请输入样品数量')" clearable
          :style="{ width: '100%' }">
        </el-input>
      </el-form-item>
      <el-form-item :label="this.$t('system.紧急状况')" prop="Urgent_state">
        <span v-if="formData.State !== 1">{{ formData.Urgent_state }}</span>
        <el-radio-group v-else v-model="formData.Urgent_state" size="medium">
          <el-radio v-for="(item, index) in Urgent_stateOptions" :key="index" :label="item.value"
            :disabled="item.disabled">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="this.$t('All.含卤情况')" prop="Halogen">
        <span v-if="formData.State !== 1">{{ formData.Halogen }}</span>
        <el-radio-group v-else v-model="formData.Halogen" size="medium">
          <el-radio v-for="(item, index) in HalogenOptions" :key="index" :label="item.value"
            :disabled="item.disabled">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formData.State === 2 || formData.State === 4">
        <table class="zhadminadd" border="1" align="center" cellpadding="10" style="width: 100%;text-align: center;"
          cellspacing="0">
          <tr class="tdd">
            <td>实验单号</td>
            <td>{{ $t('system.实验名称') }}</td>
            <td>{{ $t('All.实验要求') + '/' + $t('All.条件') }}</td>
            <td>{{ $t('All.备注') }}</td>
            <td>操作</td>
          </tr>
          <tr class="tdd" v-for="(item, index) in testdata" :key="'testlist' + index">
            <td>{{ item.Numbers }}</td>
            <td>
              <el-input v-model="item.Experiment_name" :placeholder="$t('All.请输入实验名称')" clearable
                :style="{ width: '100%' }">
              </el-input>
            </td>
            <td><el-input v-model="item.Requirements" type="textarea"
                :placeholder="$t('All.实验要求') + '/' + $t('All.条件') + $t('All.不得超过6行')"
                :autosize="{ minRows: 2, maxRows: 2 }" :style="{ width: '100%' }"></el-input></td>
            <td>
              <el-input v-model="item.Remarks" type="textarea" :placeholder="$t('All.请输入备注')"
                :autosize="{ minRows: 2, maxRows: 2 }" :style="{ width: '100%' }"></el-input>
            </td>
            <td colspan="2" class="tdd" style="min-width: 150px;">
              <el-button type="primary" @click="addDomainmax(item, index)" size="mini">{{ $t('All.新增') }}</el-button>
              <el-button type="danger" v-show="testdata.length > 1" @click="removeDomainmax(item)" size="mini">{{
                $t('All.删除') }}</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item v-if="formData.State > 2 && formData.State !== 4">
        <table class="zhadminadd" border="1" align="center" cellpadding="10" style="width: 100%;text-align: center;"
          cellspacing="0">
          <tr class="tdd">
            <td>实验单号</td>
            <td>{{ $t('system.实验名称') }}</td>
            <td>{{ $t('All.实验要求') + '/' + $t('All.条件') }}</td>
            <td v-if="formData.State === 5 || formData.State === 10">实验结果</td>
            <td v-if="formData.State === 5 || formData.State === 10">状态</td>
            <td>{{ $t('All.备注') }}</td>
            <td>操作</td>
          </tr>
          <tr class="tdd" v-for="(item, index) in testdata" :key="'testlist' + index">
            <td style="width: 150px;">{{ item.Numbers }}</td>
            <td>
              {{ item.Experiment_name }}
            </td>
            <td>
              {{ item.Requirements }}
            </td>
            <td v-if="formData.State === 5 || formData.State === 10">
              {{ item.Results ? item.Results : '等待结果' }}
            </td>
            <td v-if="formData.State === 5 || formData.State === 10">
              {{ item.State === 2 ? '实验中' : item.State === 10 ? '已完成' : '未开始' }}
            </td>
            <td>
              {{ item.Remarks }}
            </td>
            <td colspan="2" class="tdd" style="width: 80px;">
              <el-button type="primary" size="mini" @click="Lookfun(item.Numbers)">{{ $t('All.查看') }}</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item :label="this.$t('All.参考文件')">
        <el-upload :class="isedit ? '' : 'uploaddise'" :disabled="!isedit" list-type="picture-card"
          :action="`${$Upload}/api/Laboratory/File_user_upload/`" :data="filedata" :on-success="handsuccess"
          :file-list="fileList">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="xsimg(file)" :alt="file.name">
            <span class="el-upload-list__item-actions" :alt="file.name">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="handleDownload(file)">
                <i class="el-icon-download"></i>
              </span>
              <span class="el-upload-list__item-delete" v-if="isedit" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
            <p>{{ file.name }}</p>
          </div>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-upload>
      </el-form-item>
      <el-form-item :label="this.$t('All.备注')">
        {{ formData.Remarks }}
      </el-form-item>
      <el-form-item :label="$t('All.签核记录')">
        <el-radio-group style="padding-bottom: 20px;padding-left: 5%;" v-model="reverse">
          <el-radio :label="true">{{ $t('All.倒序') }}</el-radio>
          <el-radio :label="false">{{ $t('All.正序') }}</el-radio>
        </el-radio-group>
        <el-timeline :reverse="reverse">
          <el-timeline-item v-for="(activity, index) in Signlog" :key="index" :timestamp="activity.Date">
            {{ activity.Action }}
            <p>{{ activity.Opinion }}</p>
          </el-timeline-item>
        </el-timeline>
      </el-form-item>
    </el-form>
    <Qianhe v-if="qianhe" :Qianhecolse="Qianhecolse" :QianForm="QianForm" :State="formData.State"></Qianhe>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Qianhe from './YldsQianhe.vue'
export default {
  components: {
    Qianhe
  },
  data () {
    return {
      formData: {},
      qianhe: false,
      Signlog: [],
      reverse: true,
      rules: {
        Date: [{
          required: true,
          message: this.$t('All.请输入开单日期'),
          trigger: 'blur'
        }],
        Gongdan: [{
          required: true,
          message: this.$t('All.IQC请输入采购单号工程QE请输入项目号其它QC请输入工单号'),
          trigger: 'blur'
        }],
        Numbers: [{
          required: true,
          message: this.$t('All.请输入通知单号'),
          trigger: 'blur'
        }],
        Product_item: [{
          required: true,
          message: this.$t('All.请输入品名料号'),
          trigger: 'blur'
        }],
        Customer_manufacturer: [{
          required: true,
          message: this.$t('All.请输入客户厂商'),
          trigger: 'blur'
        }],
        Experiment_name: [{
          required: true,
          message: this.$t('All.请输入实验名称'),
          trigger: 'blur'
        }],
        Quantity: [{
          required: true,
          message: this.$t('All.请输入样品数量且只能输入数字'),
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d+)?$/,
          message: this.$t('All.只能输入数字'),
          trigger: 'blur'
        }],
        Urgent_state: [{
          required: true,
          message: this.$t('All.紧急状况不能为空'),
          trigger: 'change'
        }],
        Halogen: [{
          required: true,
          message: this.$t('All.含卤情况不能为空'),
          trigger: 'change'
        }],
        Requirements: [{
          required: true,
          message: this.$t('All.请输入实验要求条件'),
          trigger: 'blur'
        }]
      },
      Urgent_stateOptions: [{
        label: this.$t('All.特急'),
        value: this.$t('All.特急')
      }, {
        label: this.$t('All.急'),
        value: this.$t('All.急')
      }, {
        label: this.$t('All.普通'),
        value: this.$t('All.普通')
      }],
      HalogenOptions: [{
        label: 'HF',
        value: 'HF'
      }, {
        label: 'HSF',
        value: 'HSF'
      }],
      fileList: [],
      filedata: {
        Numbers: '',
        Type: 0,
        User: this.$store.state.Login.User,
        Username: this.$store.state.Login.Username,
        Factory: this.$store.state.Login.Factory
      },
      isedit: false,
      dialogVisible: false,
      dialogImageUrl: '',
      testdata: [
        {
          Numbers: '',
          Experiment_name: '',
          Requirements: '',
          Remarks: '',
          Number: ''
        }
      ]
    }
  },
  computed: {},
  watch: {},
  async created () {
    await this.LaUserGetAllFiles(this.$store.state.Testdata.Numbers)
    await this.GetLaboratrySignhd(this.$store.state.Testdata.Numbers)
    if (this.testdata.length === 0 && (this.formData.State === 2 || this.formData.State === 4)) {
      this.testdata = [
        {
          Numbers: '',
          Experiment_name: '',
          Requirements: '',
          Remarks: '',
          Number: ''
        }
      ]
    }
    if ((this.formData.State === 2 || this.formData.State === 4) & this.testdata.length === 1) {
      this.testdata[0].Numbers = await this.LaCount()
      this.testdata[0].Number = this.formData.Numbers
    }
    if (this.formData.State === 1) {
      this.isedit = true
    } else {
      this.isedit = false
    }
    this.Signloglist(this.formData.Numbers)
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename'],
  mounted () { },
  methods: {
    ...mapMutations(['Testdata', 'TabComponentFun']),
    async GetLaboratrySignhd (row) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.get('/api/Laboratory/GetLaboratrySignhd?Numbers=' + row)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(res.response)
        }
        loadingInstance.close()
        this.formData = res.response.data
        this.testdata = res.response.datalist
      } catch (error) {
        loadingInstance.close()
        this.$message.error(error)
      }
    },
    async LaCount () {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.post('/api/Laboratory/LaCount')
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(res.response)
        }
        loadingInstance.close()
        return res.response
      } catch (error) {
        loadingInstance.close()
        return this.$message.error(error)
      }
    },
    getCurrentTime () {
      // 获取当前时间并打印
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      // 时
      const hour = new Date().getHours()
      // 分
      const minute = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      // 秒
      const second = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()

      const gettime = yy + '-' + mm + '-' + dd + ' ' + hour + ':' + minute + ':' + second
      return gettime
    },
    async handsuccess (response) {
      const data = {
        name: '',
        url: ''
      }
      if (response.status !== 200) return this.$message.error(this.$t('All.图片上传失败'))
      data.name = response.name
      data.url = response.url
      this.fileList.splice(0, 0, data)
    },
    async handleRemove (file) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        var row = {
          Name: file.name,
          Type: this.Type,
          Numbers: this.filedata.Numbers
        }
        const { data: res } = await this.$http.post('/api/Laboratory/File_user_del', row)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.数据异常'))
        }
        loadingInstance.close()
        this.fileList.some((item, i) => {
          if (item.name === file.name) {
            this.fileList.splice(i, 1)
          }
        })
        this.$message.success(`${this.$t('All.删除')}${file.name}${this.$t('All.成功')}！`)
      } catch (error) {
        this.$message.error(error)
        loadingInstance.close()
      }
    },
    async LaUserGetAllFiles (row) {
      try {
        const { data: res } = await this.$http.get('/api/Laboratory/LaUserGetAllFiles?Number=' + row + '&Factory=' + this.$store.state.Login.Factory)
        if (res.status !== 200) return
        this.fileList = res.response
      } catch (error) {
        alert(error)
      }
    },
    xsimg (val) {
      var index = val.name.lastIndexOf('.')
      const obj = val.name.substring(index + 1, val.name.length)
      const objj = obj.toUpperCase()
      switch (objj) {
        case 'JPEG':
          return val.url
        case 'BMP':
          return val.url
        case 'TIFF':
          return val.url
        case 'GIF':
          return val.url
        case 'PNG':
          return val.url
        case 'JPG':
          return val.url
        case 'PDF':
          return require('@/assets/Img/pdf.jpg')
        case 'XLS':
          return require('@/assets/Img/excle.jpg')
        case 'XLSX':
          return require('@/assets/Img/excle.jpg')
        case 'RAR':
          return require('@/assets/Img/rar.jpeg')
        case 'ZIP':
          return require('@/assets/Img/rar.jpeg')
        default:
          return require('@/assets/Img/nullimg.jpeg')
      }
    },
    resetForm () {
      this.$refs.elForm.resetFields()
    },
    async addDomainmax (item, index) {
      const contr = {
        Numbers: '',
        Number: '',
        Experiment_name: '',
        Requirements: '',
        Remarks: ''
      }
      contr.Number = this.formData.Numbers
      contr.Numbers = await this.LaCount()
      this.testdata.splice(index + 1, 0, contr)
      for (let i = 0; i < this.testdata.length; i++) {
        this.testdata.Index = i
      }
    },
    removeDomainmax (item) {
      var index = this.testdata.indexOf(item)
      if (index !== -1) {
        this.testdata.splice(index, 1)
      }
      for (let i = 0; i < this.testdata.length; i++) {
        this.testdata.Index = i
      }
    },
    Qianhecolse () {
      this.qianhe = false
    },
    async QianForm (row) {
      row.State = this.formData.State
      const data = {
        Laboratorydatahd: this.formData,
        Signstae: row,
        Laboratorylist: this.testdata
      }
      // TODO 提交表单
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.post('/api/Laboratory/LaboratrySignhd', data)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(res.response)
        }
        loadingInstance.close()
        this.Testdata = []
        this.Renewtargename(this.$t('All.一料多送待审区'), 'YldsExamine', 'Lagetflowhd')
        this.RemoveTab(this.formData.Numbers)
      } catch (error) {
        loadingInstance.close()
        console.log(error)
        alert(this.$t('All.网络异常'))
      }
    },
    async Lookfun (row) {
      try {
        const { data: res } = await this.$http.post('/api/Laboratory/Getlabdata?Numbers=' + row)
        if (res.status !== 200) return alert(res.msg)
        this.Testdata(res.response)
        this.Addtab(res.response.Numbers, 'Testflow')
      } catch (error) {
        alert(error)
      }
    },
    async Signloglist (row) {
      try {
        const { data: res } = await this.$http.post('/api/Laboratory/Signloglist?Numbers=' + row)
        if (res.status !== 200) return
        this.Signlog = res.response
      } catch (error) {
        alert(error)
      }
    },
    handlePictureCardPreview (file) {
      if (file.url.indexOf('http') !== -1) {
        window.open(file.url)
      } else {
        window.open(this.$Upload + file.url)
      }
    },
    handleDownload (file) {
      var url = file.url
      var alink = document.createElement('a')
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        alink.href = URL.createObjectURL(blob)
        alink.download = file.name
        document.body.appendChild(alink)
        alink.click()
      })
    },
    async Resendtest (row) {
      const loadingInstance = this.$loading({ text: this.$t('system.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        const { data: res } = await this.$http.get('/api/Laboratory/Resendtest?Numbers=' + row)
        if (res.status !== 200) {
          loadingInstance.close()
          return this.$message.error(res.response)
        }
        loadingInstance.close()
        this.Testdata(res.response)
        this.Addtab(res.response.Numbers, 'Testsheethdxq', [])
      } catch (error) {
        loadingInstance.close()
        alert(error)
      }
    }
  }
}

</script>
<style lang="less" scoped>
:deep(.updata .el-upload .el-upload--picture-card) {
  display: none;
}
</style>>
